import React, { useState, useMemo, useEffect, useCallback } from "react";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Select } from "antd";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import {
  DeleteOutlined,
  PauseCircleOutlined,
  SwapOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import { Tables } from "../../../../../components/Elements/Tables/Tables";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import SortData from "../../../../../components/Elements/SortData.js/SortData";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import BasicDetailsFormCard from "./BasicDetailsFormCard";
import CreateRoles from "../../Users/DailogBoxes/CreateRoles";
import { getApi, postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import moment from "moment";
import ApplyAssignForm from "../DailogBoxes/ApplyAssignForm";
import LimitExceedPopup from "../DailogBoxes/LimitExceedPopup";
import { Modal } from "antd";
import PopupCard from "../../../../Auth/PopupCard";
import { EyeIcon } from "lucide-react";
import { useDispatch } from "react-redux";
import { fetchFormAssignments } from "../../../../../redux/ViewForm/viewFormSlice";
const { Option } = Select;

const AssignFormPage = ({
  standalone = true,
  formId: propFormId,
  projectId: propProjectId,
  formName: propFormName,
  roleType: propRoleType,
  locationId: propLocationId,
  departmentId: propDepartmentId,
  formAllotmentId: propFormAllotmentId,
  isEmployeeRoute: isEmployeeRouteProp,
  formType: propFormType,
  allotmentType: propAllotmentType,
  onClose,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { id: paramId } = useParams(); // formId
  const isEmployeeRoute =
    typeof isEmployeeRouteProp === "boolean"
      ? isEmployeeRouteProp
      : location.pathname.startsWith("/employee");

  // Use props if provided, otherwise fallback to URL params or location state
  const id = propFormId || paramId;
  const {
    roleType: stateRoleType,
    projectId: stateProjectId,
    formName: stateFormName,
    locationId: stateLocationId,
    departmentId: stateDepartmentId,
    formAllotmentId: stateFormAllotmentId,
    formType: stateFormType,
    allotmentType: stateAllotmentType,
  } = location.state || {};
  const projectId = propProjectId || stateProjectId;
  const formName = propFormName || stateFormName;
  const roleType = propRoleType !== undefined ? propRoleType : stateRoleType;
  console.log(roleType, "roletypedccdcd");
  const normalizeId = (val) => (typeof val === "object" ? val?._id : val);
  const locationId = normalizeId(propLocationId || stateLocationId || "");
  const departmentId = normalizeId(propDepartmentId || stateDepartmentId || "");
  const useScopeEmployees = Boolean(locationId || departmentId);
  const formAllotmentId =
    propFormAllotmentId ||
    stateFormAllotmentId ||
    (isEmployeeRoute ? paramId : "");
  const resolvedFormType = (
    propFormType ||
    stateFormType ||
    "standard"
  ).toString();
  const resolvedAllotmentType = (
    propAllotmentType ||
    stateAllotmentType ||
    "fill"
  ).toString();

  const _user = useSelector((state) => state.auth.user);
  const clientId = _user?.client_id?._id || _user?._id;

  const [selectedRoles, setSelectedRoles] = useState(null);
  const [activeTab, setActiveTab] = useState("assign");
  const [dynamicData, setDynamicData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [currentCardPage, setCurrentCardPage] = useState(1);
  const [openCreateDailog, setOpenCreateDailog] = useState(false);
  const [selectedSection, setSelectedSection] = useState([]);
  const [openProceedApply, setOpenProceedApply] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [openLimitExceedsPopUp, setOpenLimitExceedsPopUp] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isAssigning, setIsAssigning] = useState(false);

  const fetchUserData = async (
    clientId,
    formId,
    projectId,
    page = 1,
    searchValue = "",
  ) => {
    try {
      setLoading(true);
      const skip = (page - 1) * pageSize;

      if (useScopeEmployees && activeTab === "assign") {
        const response = await getApi({
          apiUrl: API_URLS.GET_EMPLOYEES_BY_SCOPE({
            locationId: normalizeId(locationId), // ✅ normalize again before sending
            departmentId: normalizeId(departmentId),
            role: selectedRoles || "",
            projectId: projectId || "",
            formId: formId || "",
            isUnassigned: true,
          }),
        });
        const rawEmployees = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.data?.data)
            ? response.data.data
            : [];

        const normalizedSearch = searchValue?.trim().toLowerCase();
        const filteredBySearch = normalizedSearch
          ? rawEmployees.filter((emp) => {
              const name = emp?.name?.toLowerCase() || "";
              const email = emp?.email?.toLowerCase() || "";
              const employeeId = emp?.employee_id?.toLowerCase() || "";
              return (
                name.includes(normalizedSearch) ||
                email.includes(normalizedSearch) ||
                employeeId.includes(normalizedSearch)
              );
            })
          : rawEmployees;

        const pagedEmployees = filteredBySearch.slice(skip, skip + pageSize);

        const allUsers = pagedEmployees.map((user, index) => ({
          key: user._id,
          srNo: (
            <div className="text-center" title="">
              {skip + (index + 1)}
            </div>
          ),
          name: (
            <div className="text-center" title="">
              {user.name}
            </div>
          ),
          email: (
            <div className="text-center" title="">
              {user.email}
            </div>
          ),
          role: Array.isArray(user.role)
            ? user.role.join(", ")
            : user.role || "-",
          assignedStatus: "Not Assigned",
          action: (
            <div
              className="flex justify-center items-center gap-2 sm:gap-3"
              title=""
            >
              <div
                onClick={() => {
                  navigate("/organization/user-management/user-details", {
                    state: {
                      userId: user._id,
                      source: "assign-form",
                    },
                  });
                }}
                className="flex gap-1 sm:gap-2 items-center justify-center cursor-pointer"
                title=""
              >
                <EyeIcon />
              </div>
            </div>
          ),
        }));

        setCurrentPage(page);
        setTotalCount(filteredBySearch.length);
        setPageSize(pageSize);
        setDynamicData(allUsers);
        setFilteredData(allUsers);
        return;
      }

      // Client APIs disabled on employee dashboard
      if (isEmployeeRoute) {
        setDynamicData([]);
        setFilteredData([]);
        setTotalCount(0);
        return;
      }

      const response = await getApi({
        apiUrl: API_URLS.GET_STANDARDFORM_ASSIGNED_USER(
          projectId,
          formId,
          clientId,
          pageSize,
          page,
          "createdAt",
          searchValue,
          skip,
          selectedRoles || "",
        ),
      });

      const allUsers = response.data.map((user, index) => ({
        key: user._id,
        srNo: (
          <div className="text-center" title="">
            {skip + (index + 1)}
          </div>
        ),
        name: (
          <div className="text-center" title="">
            {user.name}
          </div>
        ),
        email: (
          <div className="text-center" title="">
            {user.email}
          </div>
        ),
        role: Array.isArray(user.role) ? user.role.join(", ") : user.role,
        formname: (
          <div className="text-center" title="">
            {user.formname || "N/A"}
          </div>
        ),
        status: (
          <div className="text-center" title="">
            {user.assignedStatus}
          </div>
        ),
        assignedStatus: user.assignedStatus, // ✅ Store raw status for filtering
        action: (
          <div
            className="flex justify-center items-center gap-2 sm:gap-3"
            title=""
          >
            {activeTab !== "assign" ? (
              <Select
                placeholder="Action"
                style={{ width: 118 }}
                dropdownStyle={{ borderRadius: "8px" }}
                className="text-sm custom-green-select"
                onChange={(value) => {
                  if (value === "preview") {
                    navigate("/organization/user-management/user-details", {
                      state: {
                        userId: user._id,
                        source: "assign-form",
                      },
                    });
                  }
                }}
              >
                <Option
                  value="assign"
                  disabled={user.assignedStatus !== "Assigned"}
                >
                  <DeleteOutlined style={{ color: "red", marginRight: 6 }} />
                  Revoke
                </Option>
                <Option
                  value="authorize"
                  disabled={user.assignedStatus !== "Assigned"}
                >
                  <PauseCircleOutlined
                    style={{ color: "#facc15", marginRight: 6 }}
                  />
                  Pause
                </Option>
                <Option
                  value="view"
                  disabled={user.assignedStatus !== "Assigned"}
                >
                  <SwapOutlined style={{ color: "#000000", marginRight: 6 }} />
                  Reassign
                </Option>
              </Select>
            ) : (
              <div
                onClick={() => {
                  navigate("/organization/user-management/user-details", {
                    state: {
                      userId: user._id,
                      source: "assign-form",
                    },
                  });
                }}
                className="flex gap-1 sm:gap-2 items-center justify-center cursor-pointer"
                title=""
              >
                <EyeIcon />
              </div>
            )}
          </div>
        ),
      }));
      console.log(allUsers, "allusersAssign");
      console.log(allUsers, "filterbyroles");

      // Update pagination
      setCurrentPage(response.currentPage);
      setTotalCount(response.total);
      setPageSize(response.pageSize);
      setDynamicData(allUsers);
      setFilteredData(allUsers);

      // let updatedata = allUsers.filter(
      //   (user) =>
      //     user.status.props.children == "Assigned" &&
      //     user.role?.toLowerCase().includes(selectedRoles.toLowerCase()),
      // );
      // updatedata.map((record) => {
      //   setSelectedRows((prev) => {
      //     const exists = prev.find((row) => row.key === record.key);
      //     if (exists) {
      //       return prev.filter((row) => row.key !== record.key);
      //     } else {
      //       return [...prev, record];
      //     }
      //   });
      // });
    } catch (error) {
      console.error("Error fetching user data:", error);
      setDynamicData([]);
      setFilteredData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserDataAssigned = async (
    clientId,
    formId,
    projectId,
    page = 1,
    searchValue = "",
  ) => {
    console.log("dfjksdljflskjffetchUserData");
    try {
      setLoading(true);
      const skip = (page - 1) * pageSize;

      // Client APIs disabled on employee dashboard
      if (isEmployeeRoute) {
        setDynamicData([]);
        setFilteredData([]);
        setTotalCount(0);
        return;
      }

      const response = await getApi({
        apiUrl: API_URLS.GET_STANDARDFORM_ASSIGNED_USER_ASSIGNED(
          projectId,
          formId,
          clientId,
          pageSize,
          page,
          "createdAt",
          searchValue,
          skip,
          selectedRoles || "",
        ),
      });

      // ✅ Map users with correct serial numbers
      const allUsers = response.data.map((user, index) => ({
        key: user._id,
        srNo: (
          <div className="text-center" title="">
            {skip + (index + 1)}
          </div>
        ),
        name: (
          <div className="text-center" title="">
            {user.name}
          </div>
        ),
        email: (
          <div className="text-center" title="">
            {user.email}
          </div>
        ),
        role: Array.isArray(user.role) ? user.role.join(", ") : user.role,
        formname: (
          <div className="text-center" title="">
            {user.formname || "N/A"}
          </div>
        ),
        status: (
          <div className="text-center" title="">
            {user.assignedStatus}
          </div>
        ),
        assignedStatus: user.assignedStatus,
        action: (
          <div
            className="flex justify-center items-center gap-2 sm:gap-3"
            title=""
          >
            <Select
              placeholder="Action"
              style={{ width: 118 }}
              dropdownStyle={{ borderRadius: "8px" }}
              className="text-sm custom-green-select"
              onChange={(value) => {
                if (value === "preview") {
                  navigate("/organization/user-management/user-details", {
                    state: {
                      userId: user._id,
                      source: "assign-form",
                    },
                  });
                }
              }}
            >
              <Option
                value="assign"
                disabled={user.assignedStatus !== "Assigned"}
              >
                <DeleteOutlined style={{ color: "red", marginRight: 6 }} />
                Revoke
              </Option>
              <Option
                value="authorize"
                disabled={user.assignedStatus !== "Assigned"}
              >
                <PauseCircleOutlined
                  style={{ color: "#facc15", marginRight: 6 }}
                />
                Pause
              </Option>
              <Option
                value="view"
                disabled={user.assignedStatus !== "Assigned"}
              >
                <SwapOutlined style={{ color: "#000000", marginRight: 6 }} />
                Reassign
              </Option>
            </Select>
          </div>
        ),
      }));
      const finalData = allUsers.filter(
        (user) => user.assignedStatus === "Assigned",
      );

      setDynamicData(finalData);
      setFilteredData(finalData);
      console.log(allUsers, "allusersssss");

      // // ✅ Filter by selectedRoles
      // const filteredByRoles = selectedRoles
      //   ? allUsers.filter((user) =>
      //     user.role?.toLowerCase().includes(selectedRoles.toLowerCase())
      //   )
      //   : allUsers;

      // console.log("Filtered Assigned Users:", filteredByRoles);

      //  setDynamicData(finalData);
      // setFilteredData(finalData);
      // let finalData = [];

      // if (activeTab === "assign") {
      //   // Show only "Not Assigned" users
      //   finalData = filteredByRoles.filter(
      //     (user) => user.assignedStatus === "Not Assigned"
      //   );
      // } else {
      //   // Show only "Assigned" users
      //   finalData = filteredByRoles.filter(
      //     (user) => user.assignedStatus === "Assigned"
      //   );
      // }

      // console.log(`${activeTab} Tab - Filtered Users:`, finalData);

      // setDynamicData(finalData);
      // setFilteredData(finalData);

      // Update pagination
      setCurrentPage(response.currentPage);
      setTotalCount(response.total);
      setPageSize(response.pageSize);
    } catch (error) {
      console.error("Error fetching assigned users:", error);
      setDynamicData([]);
      setFilteredData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (clientId && id && (projectId || useScopeEmployees)) {
      if (activeTab === "assign") {
        fetchUserData(clientId, id, projectId, page, searchTerm);
      } else if (projectId) {
        fetchUserDataAssigned(clientId, id, projectId, page, searchTerm);
      }
    }
  };

  useEffect(() => {
    if (clientId && id && (projectId || useScopeEmployees)) {
      setCurrentPage(1);
      setSelectedRows([]); // Clear selections on tab change

      if (activeTab === "assign") {
        fetchUserData(clientId, id, projectId, 1, searchTerm);
      } else if (projectId) {
        fetchUserDataAssigned(clientId, id, projectId, 1, searchTerm);
      }
    }
  }, [
    clientId,
    id,
    projectId,
    selectedRoles,
    activeTab,
    locationId,
    departmentId,
  ]);

  const handleSearch = useCallback(
    (searchTerm) => {
      setSearchTerm(searchTerm);
      setCurrentPage(1);
      if (clientId && id && (projectId || useScopeEmployees)) {
        if (activeTab === "assign") {
          fetchUserData(clientId, id, projectId, 1, searchTerm);
        } else if (projectId) {
          fetchUserDataAssigned(clientId, id, projectId, 1, searchTerm);
        }
      }
    },
    [clientId, id, projectId, activeTab, useScopeEmployees],
  );

  const handleSelectAll = () => {
    if (selectedRows.length === filteredData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows([...filteredData]);
    }
  };

  const handleSort = (key, order) => {
    const sorted = SortData({ data: filteredData, key, order });
    setFilteredData(sorted);
    setSortBy(key);
    setSortOrder(order);
  };

  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };

  const postAssignedForm = async (formData) => {
    try {
      setIsAssigning(true);
      const response = await postApi({
        apiUrl: API_URLS.CREATE_STANDARD_ASSIGN_FORM,
        data: formData,
      });

      if (response?.success) {
        triggerPopup("success", "Success", "Form assigned successfully");
        setTimeout(() => {
          Modal.destroyAll();
          if (onClose) onClose();
        }, 2000);
        setOpenProceedApply(false);
        // Refresh data
        dispatch(
          fetchFormAssignments({ formId: id, isEmployee: false, projectId }),
        );
      } else {
        if (response?.success === false) {
          setOpenProceedApply(false);
          setOpenLimitExceedsPopUp(true);
          setTimeout(() => {
            Modal.destroyAll();
            setOpenLimitExceedsPopUp(false);
          }, 3000);
        }
        setOpenProceedApply(false);
      }
    } catch (error) {
      triggerPopup("error", "Error", "Something went wrong");
      setOpenProceedApply(false);
    } finally {
      setIsAssigning(false);
    }
  };

  const postEmployeeAllotment = async (payload) => {
    try {
      setIsAssigning(true);
      const response = await postApi({
        apiUrl: API_URLS.AUTHORIZE_HIERARCHY_LS2,
        data: payload,
      });

      if (response?.success || response?.status === 200) {
        triggerPopup("success", "Success", "Form assigned successfully");
        dispatch(
          fetchFormAssignments({ formId: id, isEmployee: true, projectId }),
        );
        setTimeout(() => {
          Modal.destroyAll();
          if (onClose) onClose();
        }, 2000);
        setOpenProceedApply(false);
        return true;
      }

      triggerPopup(
        "error",
        "Error",
        response?.message || "Failed to assign form",
      );
      setOpenProceedApply(false);
      return false;
    } catch (error) {
      triggerPopup("error", "Error", "Something went wrong");
      setOpenProceedApply(false);
      return false;
    } finally {
      setIsAssigning(false);
    }
  };

  const handleApplyProceed = () => {
    if (!selectedRows || selectedRows.length === 0) {
      triggerPopup("error", "Error", "Please select at least one user");
      return;
    }

    if (!selectedSection || selectedSection.length === 0) {
      triggerPopup("error", "Error", "Please select Section");
      return;
    }

    if (!selectedRoles) {
      triggerPopup("error", "Error", "Please select a Role");
      return;
    }

    if (!endDate) {
      triggerPopup("error", "Error", "Please select End Date");
      return;
    }
    setOpenProceedApply(true);
  };

  const handleApply = () => {
    if (isAssigning) return;
    if (isEmployeeRoute) {
      const payload = {
        formId: id,
        formType: resolvedFormType,
        allotmentType: "fill",
        projectId: projectId,
        role: selectedRoles || "",

        locationId: locationId || null,
        departmentId: departmentId || null,
        expiresAt: endDate?.toISOString(),
        recipients: selectedRows.map((user) => ({
          employeeId: user.key,
          sections: selectedSection || [],
          endDate: endDate?.$d
            ? `${endDate.$y}-${String(endDate.$M + 1).padStart(2, "0")}-${String(endDate.$D).padStart(2, "0")}T00:00:00.000Z`
            : endDate?.toISOString?.() || new Date(endDate).toISOString(),
        })),
      };

      postEmployeeAllotment(payload);
      return;
    }

    const newAssignedFormData = {
      projectId: projectId,
      templateId: id,
      role: selectedRoles,
      user: selectedRows.map((user) => ({
        id: user.key,
        sections: selectedSection,
        allotmentDate: moment().toISOString(),
        endDate: endDate?.$d
          ? `${endDate.$y}-${String(endDate.$M + 1).padStart(2, "0")}-${String(endDate.$D).padStart(2, "0")}T00:00:00.000Z`
          : endDate?.toISOString?.() || new Date(endDate).toISOString(),
      })),
    };

    postAssignedForm(newAssignedFormData);
  };

  const headers = [
    ...(activeTab === "assign"
      ? [
          {
            label: <span className="text-sm font-medium">Select</span>,
            key: "select",
            render: (_, record) => (
              <div></div>
              // <input
              //   type="checkbox"
              //   disabled={!selectedRoles}
              //   checked={!!selectedRows.find((row) => row.key === record.key)}
              //   onChange={() => {
              //     setSelectedRows((prev) => {
              //       const exists = prev.find((row) => row.key === record.key);
              //       if (exists) {
              //         return prev.filter((row) => row.key !== record.key);
              //       } else {
              //         return [...prev, record];
              //       }
              //     });
              //   }}
              //   className="accent-[#06513D] w-4 h-4"
              // />
            ),
          },
        ]
      : []),
    { label: "#", key: "srNo" },
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Role", key: "role" },
    ...(activeTab !== "assign"
      ? [
          { label: "Form Name", key: "formname" },
          { label: "Status", key: "status" },
        ]
      : []),
    { label: "Action", key: "action" },
  ];

  const cardsPerPage = 10;
  const totalPages = Math.ceil(filteredData.length / cardsPerPage);
  const currentCards = useMemo(() => {
    const start = (currentCardPage - 1) * cardsPerPage;
    const end = start + cardsPerPage;
    return filteredData.slice(start, end);
  }, [filteredData, currentCardPage]);

  const AssignFormTab = () => (
    <div className="border border-[#62caae] rounded bg-white overflow-hidden">
      {/* <div className="flex ">
        <button
          onClick={() => setActiveTab("assign")}
          className={`flex-1  text-sm font-medium w-32 py-2.5 ${
            activeTab === "assign"
              ? "bg-[#06513D] text-white"
              : "bg-white text-[#06513D] hover:bg-gray-100"
          }`}
        >
          Assign Form
        </button>

        <button
          onClick={() => setActiveTab("assigned")}
          className={`flex-1  text-sm font-medium w-32 py-2.5 ${
            activeTab === "assigned"
              ? "bg-[#06513D] text-white"
              : "bg-white text-[#06513D] hover:bg-gray-100"
          }`}
        >
          Assigned Users
        </button>
      </div> */}
    </div>
  );

  const MobileCard = ({ item }) => (
    <div
      key={item.key}
      className="bg-white rounded-xl shadow-lg border border-gray-100 p-5 mb-4 transform transition-all duration-300 hover:shadow-xl hover:scale-[1.02] hover:border-[#3BA2B9] animate-slideInUp"
    >
      <div className="flex justify-between items-center mb-4 pb-3 border-b border-gray-100">
        <span className="bg-gradient-to-r from-[#06513D] to-[#3BA2B9] text-white text-sm font-bold px-4 py-2 rounded-full">
          #{item.srNo.props.children}
        </span>
        <input
          type="checkbox"
          disabled={!selectedRoles}
          checked={!!selectedRows.find((row) => row.key === item.key)}
          onChange={() => {
            setSelectedRows((prev) => {
              const exists = prev.find((row) => row.key === item.key);
              if (exists) {
                return prev.filter((row) => row.key !== item.key);
              } else {
                return [...prev, item];
              }
            });
          }}
          className="accent-[#06513D] w-4 h-4"
        />
      </div>
      <div className="text-sm text-gray-700 space-y-2">
        <div>
          <strong>Name:</strong> {item.name.props.children}
        </div>
        <div>
          <strong>Email:</strong> {item.email.props.children}
        </div>
        <div>
          <strong>Role:</strong> {item.role}
        </div>
        {activeTab !== "assign" && (
          <>
            <div>
              <strong>Form Name:</strong> {item.formname.props.children}
            </div>
            <div>
              <strong>Status:</strong> {item.status.props.children}
            </div>
          </>
        )}
        <div>
          <strong>Action:</strong> {item.action}
        </div>
      </div>
    </div>
  );

  return (
    <div className={standalone ? "md:p-6 lg:p-0 mb-20 sm:mb-6 md:mb-6" : ""}>
      <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px]">
        Assigned Form To Fill
      </div>

      <div className={standalone ? "" : "mt-4"}>
        <div>
          <BasicDetailsFormCard
            formId={id}
            formAllotmentId={formAllotmentId}
            isEmployeeRoute={isEmployeeRoute}
            roleType={roleType}
            formName={formName}
            selectedSection={selectedSection}
            setSelectedSection={setSelectedSection}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedRole={selectedRoles}
            setSelectedRole={setSelectedRoles}
          />

          <div className="border border-[#62caae] rounded-[10px] p-4 bg-white">
            <div className="flex flex-col sm:flex-row justify-between mb-3 gap-4">
              <div className="flex flex-col sm:flex-row gap-4 items-center">
                {/* ✅ Fixed width for Select All */}
                <label className="w-24 flex gap-2 items-center text-[#06513D] text-sm font-light border border-[#06513D] px-1 py-2 rounded">
                  <input
                    type="checkbox"
                    // disabled={!selectedRoles}
                    checked={
                      filteredData.length > 0 &&
                      selectedRows.length === filteredData.length
                    }
                    onChange={handleSelectAll}
                    className="accent-[#06513D] w-4 h-4"
                  />
                  Select All
                </label>

                {/* ✅ Fixed width for Search Input */}
                <div className="w-40">
                  <SearchBar width="100%" onSearch={handleSearch} />
                </div>

                <div className="flex flex-col sm:flex-row gap-4 items-center">
                  <AssignFormTab />
                </div>
              </div>

              {activeTab === "assign" && (
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 items-center">
                  <CustomButton
                    buttonType="button"
                    variant="danger"
                    onClick={() => {
                      setSearchTerm("");
                      setSelectedRows([]);
                      setSelectedRoles(null);
                      setSelectedSection([]);
                      setEndDate(null);
                      fetchUserData(clientId, id, projectId, 1, "");
                    }}
                    buttonText="Reset"
                    className="text-sm sm:text-base !text-[#06513D] font-normal h-[42px] w-full sm:w-[100px] border border-[#06513D]"
                  />
                  <CustomButton
                    onClick={handleApplyProceed}
                    buttonType="button"
                    variant="ok"
                    buttonText="Apply"
                    className="text-sm sm:text-base font-normal h-[42px] w-full sm:w-[100px]"
                  />
                </div>
              )}
            </div>

            <div className="hidden sm:block overflow-x-auto">
              <div className="min-w-full">
                <Tables
                  data={filteredData}
                  headers={headers}
                  pageSize={pageSize}
                  current={currentPage}
                  total={totalCount}
                  sortBy={sortBy}
                  sortOrder={sortOrder}
                  onChange={handlePageChange}
                  onSort={handleSort}
                  customRender={{
                    select: (_, record) => (
                      <div className="flex items-center justify-center">
                        <input
                          type="checkbox"
                          // disabled={!selectedRoles}
                          checked={
                            !!selectedRows.find((row) => row.key === record.key)
                          }
                          onChange={() => {
                            setSelectedRows((prev) => {
                              const exists = prev.find(
                                (row) => row.key === record.key,
                              );
                              if (exists) {
                                return prev.filter(
                                  (row) => row.key !== record.key,
                                );
                              } else {
                                return [...prev, record];
                              }
                            });
                          }}
                          className="accent-[#06513D] w-4 h-4"
                        />
                      </div>
                    ),
                  }}
                />
              </div>
            </div>

            <div className="block sm:hidden px-3 pb-4">
              {currentCards.length > 0 ? (
                <>
                  {currentCards.map((item) => (
                    <MobileCard key={item.key} item={item} />
                  ))}
                  <div className="flex justify-between mt-4">
                    <button
                      onClick={() =>
                        setCurrentCardPage((p) => Math.max(p - 1, 1))
                      }
                      disabled={currentCardPage === 1}
                      className="px-4 py-2 bg-[#06513D] text-white rounded disabled:opacity-50"
                    >
                      Previous
                    </button>
                    <span className="text-sm">
                      Page {currentCardPage} of {totalPages}
                    </span>
                    <button
                      onClick={() =>
                        setCurrentCardPage((p) => Math.min(p + 1, totalPages))
                      }
                      disabled={currentCardPage === totalPages}
                      className="px-4 py-2 bg-[#06513D] text-white rounded disabled:opacity-50"
                    >
                      Next
                    </button>
                  </div>
                </>
              ) : (
                <div className="text-center py-8 text-gray-500">
                  No data found
                </div>
              )}
            </div>
          </div>

          {openCreateDailog && (
            <CreateRoles
              onOpen={openCreateDailog}
              onClose={() => setOpenCreateDailog(false)}
            />
          )}
        </div>

        {openLimitExceedsPopUp && (
          <LimitExceedPopup
            onOpen={openLimitExceedsPopUp}
            onClose={() => setOpenLimitExceedsPopUp(false)}
            selectedRole={selectedRoles}
          />
        )}

        {openProceedApply && (
          <ApplyAssignForm
            onOpen={openProceedApply}
            onClose={() => setOpenProceedApply(false)}
            handleProceed={handleApply}
            selectedRole={selectedRoles}
            selectedRows={selectedRows}
            isLoading={isAssigning}
          />
        )}

        {showPopup && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignFormPage;
